import { fetchApi } from "@/api/client";
import type { MeResponse } from "@/types/me";

export const API_ME_PATH = "/api/me" as const;

export async function fetchMe(): Promise<MeResponse> {
  return fetchApi<MeResponse>(API_ME_PATH);
}
